import React from "react";
import clsx from "clsx";

import useBalancedText from "./utils/useBalancedText";

import styles from "./Quote.module.css";

export default function Quote(props) {
  const textRef = React.useRef();

  useBalancedText(textRef);

  return (
    <div
      className={clsx(
        styles.content,
        props.className === "twitter-tweet" && styles.noBorder,
      )}
    >
      <blockquote ref={textRef} {...props} />
    </div>
  );
}
